module.exports = __webpack_public_path__ + "img/navigator.afe84306.png";